










import { IBrand } from "@/models/brands";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
    "domains-grid": () =>
      import("@/components/app/admin/upmind/domainsGrid.vue")
  }
})
export default class UpmindDomainsModal extends Vue {
  @Prop({ required: true })
  public brandName!: IBrand["name"];

  @Prop({ required: true })
  public brandDomains!: IBrand["oauth_clients"];
}
